import PropTypes from "prop-types";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { TextField, Button } from "@material-ui/core";
import { _ } from "../utils/i18n";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    margin: "80px 0",
    justifyContent: "center",
    alignItems: "center",
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 30,
    padding: 20,
    [theme.breakpoints.down(770)]: {
      flexWrap: "wrap",
      padding: 0,
      margin: "40px 0",
    },
  },
  img: {
    width: "100%",
    maxWidth: 550,
    height: 556,
    objectFit: "cover",
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 30,
    [theme.breakpoints.down(770)]: {
      display: "none",
    },
  },
  form: {
    width: "100%",
    maxWidth: 620,
    display: "flex",
    flexDirection: "column",
    paddingLeft: 40,
    [theme.breakpoints.down(770)]: {
      padding: 20,
    },
  },
  radio: {
    fontStyle: "italic",
  },
}));

export default function SendForm({ url }) {
  const classes = useStyles();
  return (
    <div id="career" className={classes.container}>
      <Helmet
        script={[
          {
            type: "text/javascript",
            innerHTML: `var cf7 = document.getElementById('form-cf7'); var sentCounter = 0; if(cf7 && sentCounter<1){ cf7Active(); }else{ window.addEventListener("scroll", cf7Activator, {passive: true}); } function cf7Activator(){ var elementExists = document.getElementById("form-cf7"); if(elementExists){ cf7Active(); window.removeEventListener("scroll", cf7Activator, {passive: true}); } } function onButtonClick() {
                     var message = Validate(document.getElementById("form-cf7"));
                     var errorMessage = document.getElementById("errorMessage");
                     if(message==''){
                     errorMessage.innerHTML = '';
                     }else{
                     errorMessage.innerHTML = message;
                     return false;
                     }
                     sentCounter++; var bttn = document.getElementById('submitCf7Button'); bttn.disabled = true; bttn.setAttribute('style','opacity:0.5;margin-top: 20px;border-radius: 50px;width: 150px;height: 40px'); bttn.innerHTML = 'Sender inn skjema...'; var xhttp = new XMLHttpRequest(); xhttp.onreadystatechange = function() { if (this.readyState === 4 && this.status === 200) {  if(this.responseText.includes("mail_sent")){ window.location.href = 'https://enklerevalg.no/takk-for-din-melding/'; } } }; xhttp.open("POST", "${url}", true); xhttp.send(new FormData(document.getElementById('form-cf7')));  } function cf7Active(){ document.getElementById('form-cf7').addEventListener('submit', replaceTheDefault, false); var inputs = document.querySelectorAll( '.inputfile' ); Array.prototype.forEach.call( inputs, function( input ) { var label = input.nextElementSibling, labelVal = label.innerHTML; input.addEventListener( 'change', function( e ) { var fileName = escape(this.value).split('%5C').pop(); label.innerHTML = unescape(fileName); }); }); } function replaceTheDefault(evt){ evt.preventDefault(); onButtonClick(); /*document.getElementById('form-cf7').removeEventListener('submit', replaceTheDefault, false); */ } var _validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png", '.doc','.docm','.docx','.docx','.pdf','.txt','.xls','.xlsx','xlsm'];
                     function emailIsValid (email) {
                       return /\\S+@\\S+\\.\\S+/.test(email)
                     }
                     function Validate(oForm) {
                         var arrInputs = oForm.getElementsByTagName("input");
                         for (var i = 0; i < arrInputs.length; i++) {
                             var oInput = arrInputs[i];
                             if (oInput.type == "file") {
                                 var sFileName = oInput.value;
                                 if (sFileName.length > 0) {
                                     var blnValid = false;
                                     for (var j = 0; j < _validFileExtensions.length; j++) {
                                         var sCurExtension = _validFileExtensions[j];
                                         if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                                             blnValid = true;
                                             break;
                                         }
                                     }

                                     if (!blnValid) {
                                         return "${_(
                                           "Bare bilder og dokumenter kan lastes opp. Vennligst sjekk vedlagte filer."
                                         )}";
                                     }
                     }else{
                     return 'Legg till CV';
                     }
                     }else if(oInput.name === "your-name" && oInput.value === ''){
                         return "${_("Skriv inn Navn")}";
                     }else if(oInput.name === "your-email"){
                     var mailformat = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$/;
                     if(mailformat.test(oInput.value) === false){
                     return "${_("Skriv inn en riktig E-post")}";
                     }
                     }else if(oInput.name === "your-phone" && oInput.value === ''){
                         return "${_("Skriv inn telefon")}";
                     }
                         }

                         return '';
                     }
                     `,
          },
        ]}
      />

      <div className="col-container" style={{ padding: "0 20px" }}>
        <form
          noValidate
          autoComplete="off"
          id="form-cf7"
          encType="multipart/form-data"
        >
          <TextField
            id="outlined-textfield"
            style={{ width: "100%" }}
            label={_("Navn")}
            name="your-name"
            type="text"
            autoComplete="none"
            margin="dense"
            variant="outlined"
          />
          <TextField
            id="outlined-email-input"
            style={{ width: "100%" }}
            label={_("E-postadresse")}
            type="email"
            name="your-email"
            autoComplete="email"
            margin="dense"
            variant="outlined"
          />
          <TextField
            id="outlined-textfield"
            style={{ width: "100%" }}
            label={_("Telefon")}
            name="your-phone"
            autoComplete="none"
            margin="dense"
            variant="outlined"
          />
          <TextField
            id="outlined-textfield"
            style={{ width: "100%" }}
            label={_("CV")}
            type="file"
            name="your-cv"
            InputLabelProps={{
              shrink: true,
            }}
            autoComplete="none"
            margin="dense"
            variant="outlined"
          />
          <TextField
            id="outlined-textfield"
            style={{ width: "100%" }}
            label={_("LinkedIn")}
            name="your-linkedin"
            placeholder={_("Link til din linkedIn")}
            autoComplete="none"
            margin="dense"
            variant="outlined"
          />
          <TextField
            id="outlined-textfield"
            style={{ width: "100%" }}
            label={_("Portfolio")}
            placeholder={_("Link til din designprofil")}
            name="your-link-profile"
            autoComplete="none"
            color="primary"
            margin="dense"
            variant="outlined"
          />
          <Button
            variant="contained"
            color="primary"
            size="medium"
            id="submitCf7Button"
            type="submit"
            style={{ marginTop: 20, borderRadius: 50, width: 200 }}
          >
            {_("Send")}
          </Button>
          <span id="errorMessage" style={{ color: "#c00000" }}></span>
        </form>
      </div>
    </div>
  );
}

SendForm.propTypes = {
  url: PropTypes.string,
};

SendForm.defaultProps = {
  url: `${process.env.GATSBY_WORDPRESS_URL}/wp-json/contact-form-7/v1/contact-forms/1206/feedback`,
};
